<div class="catalog-stats-page" (window:resize)="onResize()">
  <!-- Header block -->
  <div class="cs-header">
    <h2 class="cs-title">{{variables?.catalogStatsTitle || 'Estadísticas del Catálogo'}}</h2>
    <p class="cs-subtitle">{{variables?.catalogStatsSubtitle || 'Análisis de precisión y rendimiento de los
    catálogos de estimación'}}</p>
    <div class="cs-selector">
      <mat-form-field appearance="outline" class="cs-select-field">
        <mat-label>{{variables?.selectCatalog || 'Seleccionar catálogo'}}</mat-label>
        <mat-select [(value)]="selectedCatalogId" (selectionChange)="onCatalogChange()">
          @for (cat of catalogs; track cat) {
            <mat-option [value]="cat.id">
              {{cat.catalogName || cat.name}} @if (cat.state === 'Incompleto') {
              <span class="cs-cat-state">·
              Draft</span>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>

<!-- Loading spinner -->
@if (loading) {
  <div class="cs-loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}

@if (!loading && selectedCatalog) {
  <div>
    <!-- KPI Cards -->
    <div class="cs-kpi-grid">
      <div class="cs-kpi-card cs-kpi-projects">
        <div class="cs-kpi-icon">📁</div>
        <div class="cs-kpi-body">
          <span class="cs-kpi-value">{{kpiProjects}}</span>
          <span class="cs-kpi-label">{{variables?.projectsWithCatalog || 'Proyectos'}}</span>
        </div>
      </div>
      <div class="cs-kpi-card cs-kpi-estimated">
        <div class="cs-kpi-icon">📋</div>
        <div class="cs-kpi-body">
          <span class="cs-kpi-value">{{kpiTotalEstimated | number:'1.0-0'}} h</span>
          <span class="cs-kpi-label">{{variables?.totalEstimated || 'Total Estimado'}}</span>
        </div>
      </div>
      <div class="cs-kpi-card cs-kpi-real">
        <div class="cs-kpi-icon">⏱️</div>
        <div class="cs-kpi-body">
          <span class="cs-kpi-value">{{kpiTotalReal | number:'1.0-0'}} h</span>
          <span class="cs-kpi-label">{{variables?.totalReal || 'Total Real'}}</span>
        </div>
      </div>
      <div class="cs-kpi-card cs-kpi-deviation">
        <div class="cs-kpi-icon">📊</div>
        <div class="cs-kpi-body">
          <span class="cs-kpi-value" [ngClass]="getDeviationClass(kpiDeviationPercent)">{{kpiDeviationPercent
            > 0 ? '+' :
          ''}}{{kpiDeviationPercent | number:'1.1-1'}}%</span>
          <span class="cs-kpi-label">{{variables?.csDeviation || 'Desviación'}}</span>
        </div>
      </div>
    </div>
    <!-- Charts Row 1: Unit Effort + Deviation -->
    <div class="cs-charts-row">
      <div class="cs-chart-card">
        <div class="cs-chart-header">
          <h5>{{variables?.unitEffort || 'Esfuerzo Unitario: Base vs Real Promedio'}}</h5>
        </div>
        @if (taskStats.length > 0) {
          <div id="cs-chart-unit-effort" class="cs-chart-container"></div>
        }
        @if (taskStats.length === 0) {
          <div class="cs-chart-empty">
            <span class="cs-empty-icon">📉</span>
            <p>{{variables?.noImputationData || 'Sin datos de imputación'}}</p>
          </div>
        }
      </div>
      <div class="cs-chart-card">
        <div class="cs-chart-header">
          <h5>{{variables?.avgDeviation || 'Desviación Promedio por Tipo de Tarea'}}</h5>
        </div>
        @if (taskStats.length > 0) {
          <div id="cs-chart-deviation" class="cs-chart-container"></div>
        }
        @if (taskStats.length === 0) {
          <div class="cs-chart-empty">
            <span class="cs-empty-icon">📊</span>
            <p>{{variables?.noImputationData || 'Sin datos de imputación'}}</p>
          </div>
        }
      </div>
    </div>
    <!-- Charts Row 2: Precision scatter (full width) -->
    <div class="cs-charts-row cs-charts-row-full">
      <div class="cs-chart-card cs-chart-card-full">
        <div class="cs-chart-header">
          <h5>{{variables?.estimationPrecision || 'Precisión de Estimación (Total Acumulado)'}}</h5>
        </div>
        @if (filteredImputations.length > 0) {
          <div id="cs-chart-precision" class="cs-chart-container"></div>
        }
        @if (filteredImputations.length === 0) {
          <div class="cs-chart-empty">
            <span class="cs-empty-icon">🎯</span>
            <p>{{variables?.noImputationData || 'Sin datos de imputación'}}</p>
          </div>
        }
      </div>
    </div>
    <!-- Detailed Statistics Table -->
    <div class="cs-section">
      <h4>{{variables?.detailedStats || 'Estadísticas Detalladas por Tipo de Tarea'}}</h4>
      @if (taskStats.length > 0) {
        <div class="cs-table-wrapper">
          <table class="cs-table">
            <thead>
              <tr>
                <th>{{variables?.task || 'Tarea'}}</th>
                <th class="text-right">{{variables?.projects || 'Registros'}}</th>
                <th class="text-right">{{variables?.effortBase || 'Base catálogo'}} (h)</th>
                <th class="text-right">{{variables?.realAvg || 'Real prom.'}} (h)</th>
                <th class="text-right">{{variables?.totalEstimated || 'Total est.'}} (h)</th>
                <th class="text-right">{{variables?.totalReal || 'Total real'}} (h)</th>
                <th class="text-right">{{variables?.csDeviation || 'Desv. (%)'}}</th>
              </tr>
            </thead>
            <tbody>
              @for (t of taskStats; track t) {
                <tr>
                  <td>{{t.name}}</td>
                  <td class="text-right">{{t.projects}}</td>
                  <td class="text-right">{{t.avgBase | number:'1.1-1'}}</td>
                  <td class="text-right">{{t.avgReal | number:'1.1-1'}}</td>
                  <td class="text-right">{{t.totalEst | number:'1.0-0'}}</td>
                  <td class="text-right">{{t.totalReal | number:'1.0-0'}}</td>
                  <td class="text-right" [ngClass]="getDeviationClass(t.deviation)">
                    {{t.deviation > 0 ? '+' : ''}}{{t.deviation | number:'1.1-1'}}%
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (taskStats.length === 0) {
        <div class="cs-chart-empty cs-empty-small">
          <p>{{variables?.noImputationData || 'Sin datos de imputación'}}</p>
        </div>
      }
    </div>
    <!-- Projects list -->
    <div class="cs-section">
      <h4>{{variables?.projectsWithCatalogTitle || 'Proyectos Estimados con Este Catálogo'}}</h4>
      @if (projectList.length > 0) {
        <div class="cs-table-wrapper">
          <table class="cs-table">
            <thead>
              <tr>
                <th>{{variables?.name || 'Nombre'}}</th>
                <th>{{variables?.state || 'Estado'}}</th>
                <th class="text-right">{{variables?.totalEstimated || 'Estimado'}} (h)</th>
                <th class="text-right">{{variables?.totalReal || 'Real'}} (h)</th>
                <th class="text-right">{{variables?.csDeviation || 'Desv.'}}</th>
              </tr>
            </thead>
            <tbody>
              @for (p of projectList; track p) {
                <tr>
                  <td>{{p.name}}</td>
                  <td><span class="cs-state-badge">{{p.state}}</span></td>
                  <td class="text-right">{{p.estimated | number:'1.0-0'}}</td>
                  <td class="text-right">{{p.real !== null ? (p.real | number:'1.0-0') : '—'}}</td>
                  <td class="text-right" [ngClass]="getDeviationClass(p.deviation)">
                    @if (p.deviation !== null) {
                      <span>{{p.deviation > 0 ? '+' : ''}}{{p.deviation |
                      number:'1.1-1'}}%</span>
                    }
                    @if (p.deviation === null) {
                      <span>—</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (projectList.length === 0) {
        <div class="cs-chart-empty cs-empty-small">
          <p>{{variables?.noCatalogFound || 'No hay proyectos con este catálogo'}}</p>
        </div>
      }
    </div>
    <!-- Recommendations -->
    @if (recommendations.length > 0) {
      <div class="cs-section cs-recommendations">
        <h4>{{variables?.recommendationsTitle || 'Recomendaciones para Mejorar el Catálogo'}}</h4>
        <ul class="cs-rec-list">
          @for (rec of recommendations; track rec) {
            <li class="cs-rec-item">
              <span class="cs-rec-icon">💡</span>
              <span>{{rec}}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
</div>